import { GalaxyConfig, StarData, StarPosition } from 'types/galaxy';

export const calculateTornadoPositions = (
  starsData: StarData[],
  _config: GalaxyConfig
): StarPosition[] => {
  const maxRadius = 65;
  const minRadius = 4;
  const height = 80;

  // Sort by PnL descending
  const sorted = starsData.map((_, i) => i).sort((a, b) => starsData[b].pnl - starsData[a].pnl);
  const count = sorted.length;
  const positions: StarPosition[] = new Array(count);

  sorted.forEach((idx, rank) => {
    const t = rank / count;
    const radiusAtLevel = maxRadius * Math.pow(1 - t, 0.6) + minRadius;
    const spiralTurns = 3 + t * 12;
    const angle = spiralTurns * Math.PI * 2 * t + (Math.random() - 0.5) * 0.3;
    const r = radiusAtLevel + (Math.random() - 0.5) * (radiusAtLevel * 0.15);
    const y = height / 2 - t * height + (Math.random() - 0.5) * 1.5;

    positions[idx] = {
      x: Math.cos(angle) * r,
      y,
      z: Math.sin(angle) * r,
    };
  });

  return positions;
};
